import { buildCrmCard } from 'crm-cards-sdk/buildCrmCard';
import once from 'transmute/once';
import { useFetchAssociatedObjectsCardRedesignData } from './hooks/useFetchAssociatedObjectsCardRedesignData';
import { AssociatedObjectsCardRedesignContext } from './context/AssociatedObjectsCardRedesignContext';
import CardContent from './components/content/CardContent';
import CardActions from './components/CardActions';
import CardTitle from './components/CardTitle';
const useCardActions = once(() => () => Promise.resolve(CardActions));
const AssociatedObjectsCard = buildCrmCard({
  displayName: 'AssociatedObjectsCard',
  useLegacyDataAttributes: ({
    cardData
  }) => ({
    'data-sidebar-card-association-object-type-id': cardData.configuration.toObjectTypeId,
    'data-sidebar-key': cardData.definition.cardTitle,
    'data-sidebar-card-type': 'AssociatedObjectsCard'
  }),
  ContentComponent: CardContent,
  context: AssociatedObjectsCardRedesignContext,
  useContextValue: useFetchAssociatedObjectsCardRedesignData,
  useCardProps: () => ({}),
  enableLegacyActionFormat: true,
  // When `enableLegacyActionFormat: true` buildCrmCard expects useCardActions to return a function that resolves actions component as a promise.
  // This logic is build based on the assumption that the component is code split and loaded async.
  // We don't want AssociatedObjectsCardActionsSdkDataProvider to be code split but we still need to wrap it in a Promise to make it work with buildCrmCard.
  useCardActions,
  TitleComponent: CardTitle
});
export default AssociatedObjectsCard;